import * as STD    from '@emersya/mpa-std-lib';
import * as Basket from '@emersya/mpa-basket-lib';
import CM          from '@emersya/mpa-components-manager-lib';
import { Block, InputBool }   from '@emersya/mpa-components-lib';

export interface IStandingNumericOptionsTileComponentConfiguration extends Block.Configuration {
};

export class StandingNumericOptionsTileComponent extends Block.Component {

	override async component_initialize() {
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
		const planner = app.viewer.planner;
		if (!planner) {
			this.component_throwUserError('');
		}
	};

	async onProductChange_before(){
		const inputBoolFirstOption = <InputBool.Component>this.component_find('@:17PB02A.optionContainer.option.yesNoOption');
		const inputBoolSecondOption = <InputBool.Component>this.component_find('@:17PB02B.optionContainer.option.yesNoOption');
		await inputBoolFirstOption.updateValue(false);
		await inputBoolSecondOption.updateValue(false);
		const basket = app.basket;
		if(!basket){
			this.component_throwUserError('');
		}
		const basketBasket = app.basket.basket;
		basketBasket.products.forEach(async element => {
			const numericOptionA = element.parts.find(x => x.id === 'numericOptions-a');
			const numericOptionB = element.parts.find(x => x.id === 'numericOptions-b');
			if(numericOptionA){
				await numericOptionA.remove();
			}
			if(numericOptionB){
				await numericOptionB.remove();
			}
		})
	}

	async onValue(event : STD.events.Event<any, any>) {
		if (!app.currentProduct) {
			return;
		}
		const is17PB02A = !!event.targetsPath.find(x => x.id === '17PB02A');
		const optionSKU = is17PB02A ? '17PB02A' : '17PB02B';
		const confComponent = app.component_configuration.productsComponents.find(x => x.SKU === 'numeric-options');
		const confOption = app.component_configuration.productsOptions.find(x => x.SKU === optionSKU);
		if (
			!confComponent ||
			!confOption ||
			!confComponent.translations[ '@name' ] ||
			!confOption.translations[ '@name' ] ||
			!confOption.pricingInfo
		)
		{
			throw new Error;
		}
		const newValue = <boolean> event.details.newValue;
		const partId = is17PB02A ? 'numericOptions-a' : 'numericOptions-b';
		let part = (() => {
			try {
				return app.currentProduct.getPart([ partId ]);
			} catch (error : any) {
				return null;
			}
		})();
		if (newValue) {
			if (!part) {
				const tk = confOption.pricingInfo.pricing;
				part = app.currentProduct.createPart({
					id :            partId,
					title :         <string> confComponent.translations[ '@name' ][ app.currentLanguage ],
					reference :     new Basket.Reference(optionSKU),
					metaData :      null,
					parts :         [],
					options :       [
						{
							id :            optionSKU,
							title :         <string> confOption.translations[ '@name' ][ app.currentLanguage ],
							components :    [],
							metaData :      null,
							reference :     new Basket.Reference(optionSKU),
							technicalFees : null,
							pricingInfo :   {
								pricing :                 Basket.Pricing.deserialize(<any> tk),
								volumeComputationMethod : 'unit'
							}
						}
					],
					defaultOption : optionSKU
				});
				await part.initialize();
			}
		} else if (part) {
			await part.remove();
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingNumericOptionsTileComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};

import manifestXMLSource from './StandingNumericOptionsTile.xml';
import './StandingNumericOptionsTile.scss';

export namespace NS {
	export const Component = StandingNumericOptionsTileComponent;
	export type Component = StandingNumericOptionsTileComponent;
	export type Configuration = IStandingNumericOptionsTileComponentConfiguration;
}

CM.declare({
	id :       'standing-numericOptionsTile',
	type :     StandingNumericOptionsTileComponent,
	manifest : manifestXMLSource
});
